'use client';

import { c as _c } from "react/compiler-runtime";
import AccordionItem from '@/features/payload-cms/components/accordion/accordion-item';
import { LexicalRichTextSection } from '@/features/payload-cms/components/content-blocks/lexical-rich-text-section';
import type { MessageField } from '@payloadcms/plugin-form-builder/types';
import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import type React from 'react';
import { useId, useState } from 'react';

/**
 * A text between the fields. With a collapsible title it starts folded under it, the way an
 * accordion on a page does, for what someone only needs now and then.
 */
export const Message: React.FC<MessageField & {
  collapsibleTitle?: string | null;
}> = t0 => {
  const $ = _c(12);
  const {
    message,
    collapsibleTitle
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  const accordionId = useId();
  const t1 = message as SerializedEditorState;
  let t2;
  if ($[0] !== t1) {
    t2 = <LexicalRichTextSection richTextSection={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const text = t2;
  if (typeof collapsibleTitle !== "string" || collapsibleTitle.trim() === "") {
    let t3;
    if ($[2] !== text) {
      t3 = <div className="mb-4">{text}</div>;
      $[2] = text;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] !== collapsibleTitle) {
    t3 = <span className="font-body text-sm font-semibold text-gray-700">{collapsibleTitle}</span>;
    $[4] = collapsibleTitle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsExpanded(_temp);
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = isExpanded && text;
  let t6;
  if ($[7] !== accordionId || $[8] !== isExpanded || $[9] !== t3 || $[10] !== t5) {
    t6 = <div className="mb-4"><AccordionItem titleElement={t3} showChevron={true} accordionId={accordionId} isExpanded={isExpanded} onToggle={t4} isNested={true}>{t5}</AccordionItem></div>;
    $[7] = accordionId;
    $[8] = isExpanded;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
function _temp(expanded) {
  return !expanded;
}